module.exports = __webpack_public_path__ + "img/LTS_ACCA_2.869b283b.gif";